module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class=\'accordion\' style=\'margin-bottom: 0;\'>\n    <div class=\'accordion-group\'>\n        <div class=\'accordion-heading\'>\n            <div class=\'accordion-toggle\'>\n                <div class=\'svg_icon\'>\n                    ' +
((__t = ( WiseMetering.icon('circuits') )) == null ? '' : __t) +
'\n                </div>\n                ' +
((__t = ( i18next.t('glossary.current_schedule') )) == null ? '' : __t) +
'\n                <div class=\'wmui-btn\' id=\'edit-schedule\' style=\'float: right;\'>\n                    ' +
((__t = ( i18next.t('ui.buttons.edit') )) == null ? '' : __t) +
'\n                </div>\n            </div>\n        </div>\n        <div class=\'accordion-body\'>\n            <div class=\'accordion-inner\' id=\'circuit-schedule\' style=\'height: 560px;\'>\n\n            </div>\n        </div>\n    </div>\n</div>\n';

}
return __p
}